import {
    GET_API,
    POST_API,
    PUT_API,
    PATCH_API
} from "../../Functionalities/APIs"

import { franchise } from "../../Functionalities/Config";

export const ManageManagers = async (e, data, keyword, params) => {
    if (keyword == 'get') {
        let path = '/branch/branchmanagers/'
        // void 0
        let result = GET_API('', params, path)
        return await result.then((result) => {
            // void 0
            if (result) {
                return result
            } else {
                return 0
            }
        })
    }
    if (keyword == 'patch') {
        let path = '/branch/branchmanagers/'
        // void 0
        var fdata = new FormData();
        var fdata = new FormData();
        // void 0
        fdata.append("keyword", "remove_manager");
        fdata.append("manager_id", data.manager_id);
        let result = PATCH_API(fdata, "", path);
        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result.status;
            } else {
                return 0;
            }
        });
    }
    if (keyword == 'update') {
        let path = '/branch/branchmanagers/'
        // void 0
        var fdata = new FormData();
        // void 0
        fdata.append("manager_id", data.manager_id);
        fdata.append("is_blocked", data.is_blocked);
        let result = PUT_API(fdata, "", path);
        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result.status;
            } else {
                return 0;
            }
        });
    }

    if (keyword == 'update_full') {
        let path = '/branch/branchmanagers/'
        // void 0
        var fdata = new FormData();
        // void 0
        fdata.append('keyword', 'manager_update');
        fdata.append('manager_id', data.id);
        fdata.append('name', data.first_name);
        fdata.append('email', data.email);
        fdata.append('mobile', data.details.mobile);
        fdata.append('is_blocked', data.is_blocked);
        // if(data.userNameChanged ){
        //     fdata.append('update_type', 'manager_update');
        // }
        if (data.password) {
            fdata.append('update_type', 'manager_update');
            fdata.append('username', data.username);
            fdata.append('password', data.password);
        }
        let result = PUT_API(fdata, "", path);

        // for (var pair of fdata.entries()) {
        //     void 0
        // }
        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result;
            } else {
                return 0;
            }
        });
    }

    if (keyword == 'add') {
        let path = '/user/profile/'
        // void 0
        var fdata = new FormData();
        // void 0
        fdata.append("name", data.name)
        fdata.append("email", data.email)
        fdata.append("mobile", data.mobile)
        fdata.append("username", data.username)
        fdata.append("password", data.password)
        fdata.append("address1", data.address1)
        fdata.append("address2", data.address2)
        fdata.append("land_mark", data.land_mark)
        fdata.append("latitude", data.latitude)
        fdata.append("longitude", data.longitude)
        fdata.append("city", data.city)
        fdata.append("pin", data.pin)
        fdata.append("state", data.state)
        fdata.append("keyword", "add_manager")
        let result = POST_API(fdata, "", path);
        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result;
            } else {
                return 0;
            }
        });
    }
    if (keyword == 'add_franchise_manager' || keyword == 'add_franchise_staffs' || keyword == 'add_franchise_accountant') {
        // void 0
        let path = '/user/profile/'
        // void 0
        var fdata = new FormData();
        // void 0

        fdata.append("name", data.name)
        fdata.append("franchise_id", franchise.id)
        fdata.append("email", data.email)
        fdata.append("mobile", data.mobile)
        fdata.append("username", data.username)
        fdata.append("password", data.password)
        fdata.append("address1", data.address1)
        fdata.append("address2", data.address2)
        fdata.append("land_mark", data.land_mark)
        fdata.append("latitude", data.latitude)
        fdata.append("longitude", data.longitude)
        fdata.append("city", data.city)
        fdata.append("pin", data.pin)
        fdata.append("state", data.state)
        fdata.append("keyword", keyword)
        let result = POST_API(fdata, "", path);
        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result;
            } else {
                return 0;
            }
        });
    }

}

export const ManageSingleManagers = async (e, data, keyword, params) => {
    if (keyword == 'get') {
        let path = '/user/profile/'
        // void 0
        let result = GET_API('', params, path)
        return await result.then((result) => {
            // void 0
            if (result) {
                return result
            } else {
                return 0
            }
        })
    }
}




// export const ManageRestaurantReports=async(e,data,keyword,params)=>{
// let function_name='RestaurantReports'
// void 0
// let path='/accounts/allaccounts/'
// if(keyword=='get'){
//     void 0
//     let result=GET_API("",params,path)
//     return await result.then((result)=>{
//         void 0
//         if (result){
//             return result
//         }
//         else{
//             return 0
//         }
//     })
// }
// }
